import React from 'react';

import { useIntl } from 'react-intl-next';

import ErrorIcon from '@atlaskit/icon/core/migration/error';
import { type NoticeProps, type OptionType } from '@atlaskit/select';
import { N500 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

import { StyledBox, StyledText } from '../../styled';

import messages from './messages';

export const NoOptionsMessage = (props: NoticeProps<OptionType, true>) => {
	const { formatMessage } = useIntl();

	const hasInputValue = props.selectProps.inputValue;

	return (
		<StyledBox>
			<StyledBox height={72} iconSize={36}>
				<ErrorIcon
					spacing="none"
					color={token('color.icon.subtle', N500)}
					LEGACY_size="xlarge"
					label=""
				/>
			</StyledBox>
			<StyledText>
				{hasInputValue
					? formatMessage(messages.noOptionsMessage)
					: formatMessage(messages.noOptionsWithNoValueMessage)}
			</StyledText>
		</StyledBox>
	);
};
